import { sanitizeUrl } from "@braintree/sanitize-url";
import { RE_IFRAME, RE_IFRAME_REGEX } from "../element/embeddable";


export const normalizeLink = (link: string) => {
  if(typeof(link) != 'string')return null;
  link = link.trim();
  if (!link) {
    return link;
  }

  if (link.startsWith(RE_IFRAME)) {
    const match = link.match(RE_IFRAME_REGEX);
    const src = match![1] || match![2];
    return src;
  }

  return sanitizeUrl(link);
};

export const isLocalLink = (link: string | null) => {
  if(typeof(link) != 'string')return false;
  return !!(link?.includes(location.origin) || link?.startsWith("/"));
};

export const isValidUrl = (link:string | null)=>{
  //判断URL地址的正则表达式为:http(s)?://([\w-]+\.)+[\w-]+(/[\w- ./?%&=]*)?
  //下面的代码中应用了转义字符"\"输出一个字符"/"
  var Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
  var objExp = new RegExp(Expression);
  if (objExp.test(link as string) == true) {
    return true;
  } else {
    return false;
  }
}

export const isValidUrlHttps = (link:string | null)=>{
  //判断URL地址的正则表达式为:http(s)?://([\w-]+\.)+[\w-]+(/[\w- ./?%&=]*)?
  //下面的代码中应用了转义字符"\"输出一个字符"/"
  var Expression = /https:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
  var objExp = new RegExp(Expression);
  if (objExp.test(link as string) == true) {
    return true;
  } else {
    return false;
  }
}

/**
 * Returns URL sanitized and safe for usage in places such as
 * iframe's src attribute or <a> href attributes.
 */
export const toValidURL = (link: string) => {
  if(typeof(link) != 'string')return '';

  link = normalizeLink(link);

  // make relative links into fully-qualified urls
  if (link.startsWith("/")) {
    return `${location.origin}${link}`;
  }

  try {
    new URL(link);
  } catch {
    // if link does not parse as URL, assume invalid and return blank page
    return "about:blank";
  }

  return link;
};
